module.exports = __webpack_public_path__ + "img/47_17.41d8666c.png";